<template>
  <Modal :open.sync="open" size="small">
    <div class="dwp-space-y-4">
      <div>
        <div
          class="dwp-text-3xl dwp-text-primary dwp-leading-none dwp-mb-6"
        >Time flies when you're having fun.</div>
        <div
          class="dwp-font-bold dwp-text-gray-700 dwp-mb-6"
        >Your DocketWP beta trial has ended, but it's easy to get connected again.</div>
        <div class="dwp-text-gray-600 dwp-text-sm dwp-mb-8">
          As a way to say thanks for participating in our beta program, here's an exclusive
          deal to become a permanent part of the DocketWP family.
        </div>
        <span class="dwp-flex dwp-justify-between">
          <span class="dwp-inline-flex rounded-md">
            <a
              href="https://docketwp.com/beta-offer/"
              target="_blank"
              class="dwp-px-3 dwp-py-2 dwp-text-sm dwp-bg-transparent hover:dwp-bg-transparent dwp-text-gray-600 dwp-border hover:dwp-opacity-75 dwp-border-gray-500 dwp-inline-flex dwp-items-center dwp-border-transparent dwp-leading-4 dwp-font-medium dwp-rounded focus:dwp-outline-none dwp-transition dwp-ease-in-out dwp-duration-150"
            >Exclusive Offer For Beta Testers</a>
          </span>

          <span class="dwp-inline-flex rounded-md">
            <VButton type="plain" size="tiny" @click.native.prevent="signOut">Sign Out</VButton>
          </span>
        </span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import Logo from "@/components/illustrations/Logo.vue";
import VButton from "@/components/ui/VButton.vue";
import { sync, call } from "vuex-pathify";

export default {
  components: {
    Modal,
    VButton,
    Logo,
  },
  computed: {
    open: sync("ui/open"),
  },
  methods: {
    ...call("user", ["signOut"]),
  },
};
</script>